import React from 'react';
import Button from '../Form/Button';
import { TbCircleCheckFilled } from 'react-icons/tb';
import ButtonPrimary from '../Form/ButtonPrimary';

interface ButtonOrderTypeStartProps {
    service: any;
    nextOrderType: string | null;
    onHandleClick: (e: string) => void;
}

const ButtonOrderTypeStart = ({ service, nextOrderType, onHandleClick }: ButtonOrderTypeStartProps) => {

    const Icon = service.icon;

    return (
        service.name === nextOrderType ? (
            <ButtonPrimary
                outline
                onClick={() => onHandleClick(service.name)}
                className={`
                    relative
                    w-1/3 gap-1 shadow-md h-full min-h-max
                    grid gap-1 place-items-center leading-none
                    rounded-xl ring-inset pointer-events-none
                `}
                >
                <div className="grid place-items-center text-md gap-0.5">
                    <Icon size={32} />
                    <span className={`leading-none font-semibold ${service.label.trim().split(/\s+/).length === 1 && 'break-all'}`}>{service.label}</span>
                </div>
                <TbCircleCheckFilled size={28} className='absolute -right-1.5 -top-1.5 bg-white rounded-full text-custom-primary zoomInIconNoDelay' />
            </ButtonPrimary>
            ) : (
            <Button
                onClick={() => onHandleClick(service.name)}
                className={`
                    w-1/3 gap-1 shadow-lg h-full min-h-max
                    grid gap-1 place-items-center leading-none
                    rounded-xl ring-inset
                `}
                >
                <div className="grid place-items-center text-md gap-0.5">
                    <Icon size={32} />
                    <span className={`leading-none font-semibold ${service.label.trim().split(/\s+/).length === 1 && 'break-all'}`}>{service.label}</span>
                </div>
            </Button>
        )
    )

}

export default ButtonOrderTypeStart;